import { createApi } from 'ReduxHelpers';
import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import { type CancelSessionResponse, type ListSessionsResponse } from './lessonGenerationPortalApi.types';

enum TagType {
    LessonGenerationSession = 'LessonGenerationSession',
}

const LIST_TAG = { type: TagType.LessonGenerationSession, id: 'LIST' } as const;

export const lessonGenerationPortalApi = createApi('LessonGenerationPortalApi', {
    ...getBackRoyalApiBaseConfig('LessonGenerationPortalApi'),
    tagTypes: Object.values(TagType),
    endpoints: builder => ({
        listMyLessonGenerationSessions: builder.query<ListSessionsResponse, void>({
            query: () => ({ url: 'lesson_generations.json' }),
            providesTags: [LIST_TAG],
        }),

        cancelLessonGenerationSession: builder.mutation<CancelSessionResponse, { sessionId: string }>({
            query: ({ sessionId }) => ({
                url: 'lesson_generations/cancel.json',
                method: 'POST',
                body: { sessionId },
            }),
            invalidatesTags: [LIST_TAG],
        }),
    }),
});

export const { useListMyLessonGenerationSessionsQuery, useCancelLessonGenerationSessionMutation } =
    lessonGenerationPortalApi;
